import { Box, Flex, NavButton, ThemeTypes, isAdjustableColor, setAlpha } from '@talos/kyoko';
import styled from 'styled-components';

export const MobileLayoutWrapper = styled(Flex)<{ isPortrait: boolean }>`
  padding: ${({ theme, isPortrait }) =>
    !isPortrait
      ? `0 calc(${theme.spacing12}px + env(safe-area-inset-right)) 0 calc(${theme.spacing12}px + env(safe-area-inset-left))`
      : ''};
`;

export const Menu = styled(Flex)<{ isOpen: boolean }>`
  padding: ${({ theme }) =>
    `calc(${theme.spacing12}px + env(safe-area-inset-top)) calc(${theme.spacing12}px + env(safe-area-inset-right)) ${theme.spacing12}px calc(${theme.spacing12}px + env(safe-area-inset-left))`};
  left: 0;
  top: 0;
  bottom: 0;
  width: 80%;
  flex-direction: column;
  background: ${({ theme }) => theme.backgroundSidebar};
  box-shadow: ${({ theme, isOpen }) => (isOpen ? `0 0 25px ${theme.backgroundBody}` : 'none')};
  z-index: 4;
  position: absolute;
  transform: translateX(${({ isOpen }) => (isOpen ? '0%' : '-100%')});
  transition: transform 300ms ease-out;
`;
Menu.defaultProps = {
  p: 'spacing12',
};

export const MenuItem = styled(NavButton).attrs(attrs => ({
  ...attrs,
  ghost: true,
}))`
  width: 100%;
  font-weight: normal;
  justify-content: flex-start;
  gap: ${({ theme }) => theme.spacing8}px;
  padding: ${({ theme }) => theme.spacing8}px;
  margin-bottom: ${({ theme }) => theme.spacing8}px;
`;

export const Overlay = styled(Box)<{ hidden: boolean }>`
  inset: 0;
  background: ${({ theme }) =>
    isAdjustableColor(theme.backgroundBody)
      ? setAlpha(0.1, theme.backgroundBody)
      : theme.type === ThemeTypes.dark
        ? theme.colors.black.dim
        : theme.colors.white.dim};
  backdrop-filter: blur(${({ hidden }) => (hidden ? '0px' : '10px')});
  position: absolute;
  z-index: 3;
  opacity: ${({ hidden }) => (hidden ? 0 : 1)};
  transition:
    opacity 5000ms ease,
    backdrop-filter 5000ms ease;
  pointer-events: ${({ hidden }) => (hidden ? 'none' : 'all')};
`;
